export const USER_EVENT_TYPE = {
    SEARCH: 'SEARCH',
    HOMEPAGE_VIEW: 'HOMEPAGE_VIEW',
    PAGE_VIEW: 'PAGE_VIEW',
    ITEM_PAGE_VIEW: 'ITEM_PAGE_VIEW',
    ADD_TO_FAVORITES: 'ADD_TO_FAVORITES',
    ADD_TO_CART: 'ADD_TO_CART',
    CHECKOUT: 'CHECKOUT',
    LOGIN: 'LOGIN',
};
